import React, { Fragment } from "react";

const LightBoxDetail = ({rows}:{rows:{labels:[],values:[]}[]}) => {

    return (
        <>
            {rows.map((row, rowIndex) => (
                <Fragment key={rowIndex}>
                    <div className={`row ${rowIndex !== 0 ? "mt-4" : ""}`}>
                        {row.labels.map((label, colIndex) => (
                            <div
                                key={colIndex}
                                className="col-4 fs-16 fw-800 secondary-color"
                            >
                                {label}
                            </div>
                        ))}
                    </div>

                    <div className="row">
                        {row.values.map((value, colIndex) => (
                            <div
                                key={colIndex}
                                className="col-4 fs-16 fw-400 secondary-color"
                            >
                                {value}
                            </div>
                        ))}
                    </div>
                </Fragment>
            ))}
        </>
    );
};

export default LightBoxDetail;
